<a [href]="link" target="_blank" rel="noopener noreferrer" class="visualizer-item">
  <img [src]="imageUrl" alt="Visualizer image" class="visualizer-image"/>
  <section class="body-section">
    <p class="typography-title-s">{{ title | translate}}</p>
    <p class="typography-body-m-light">{{ description | translate }}</p>
  </section>
</a>
